<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">{{'global.menu.home' | translate}}</a></li>
      <li><a href="">{{'global.menu.admin.main'|translate}}</a></li>
      <li class="active">{{'global.menu.resendmail'|translate}}</li>
    </ol>
  </div>
  <div class="col-md-12 noBottomMargin">
    <h2 class="changePasswordHeading">{{'global.menu.resendmail'|translate}}</h2>
  </div>
  <div class="col-md-12 mainUserlockDiv">
    <div class="alert alert-success centerText" *ngIf="success">
      <a class="close" data-dismiss="alert">×</a><strong>{{'global.form.activationsuccess' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error">
      <strong>{{'sendwelcome.messages.error.general' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRWE000001">
      <strong>{{'sendwelcome.messages.error.ERRWE000001' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRWE000002">
      <strong>{{'sendwelcome.messages.error.ERRWE000002' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRWE000003">
      <strong>{{'sendwelcome.messages.error.ERRWE000003' | translate}}</strong>
    </div>
    <form [formGroup]="userSearchForm" novalidate (submit)="getuser()">
      <div class="col-md-2 noPaddingMd-12">

      </div>
      <div class="col-md-4 ">
          <input type="text"  id="employeeid" name="employeeid" formControlName="employeeId"
                 autocomplete="off" autofocus  required >
          <span class="bar"></span>
          <label>{{'global.form.employeeid' | translate}}</label>
      </div>
      <div class="col-md-4 noPaddingMd-12">
          <input type="text"  id="certificatenumber" name="certificatenumber" formControlName="certificateNumber"
                 autocomplete="off"  autofocus required >
          <span class="bar"></span>
          <label>{{'global.form.certificatenumber' | translate}}</label>
      </div>
      <div class="col-md-2 noPaddingMd-12">
      </div>

      <div class="col-md-12"></div>
      <div class="col-md-4 noPaddingMd-12">

      </div>
      <div class="col-md-4 btnDiv">
        <button type="submit"  class="btn btn-primary passBtn" >{{'global.button.search'|translate}}</button>
      </div>
    </form>
    <div class="col-md-4 noPaddingMd-12">

    </div>
    <div class="col-md-12 tableDiv noPaddingMd-12">
      <table class="table table-scrollable userTable" >
        <thead>
        <tr>
          <th colspan="3">
            {{'person.certificatenumber' | translate}}

          </th>
          <th colspan="3">
            {{'person.company' | translate}}

          </th>
          <th colspan="4">
            {{'person.name' | translate}}
          </th>
          <th colspan="3">

            {{'person.nik' | translate}}
          </th>
          <th colspan="4">
            &nbsp;

          </th>
        </tr>
        </thead>
        <tbody>
        <tr class="rowBorder" *ngFor="let user of users;let i = index">
          <td colspan="3">{{user.certificateNumber}}</td>
          <td colspan="3" >{{user.companyName}}</td>
          <td colspan="4">{{user.participantName}}</td>
          <td colspan="3">{{user.employeeId}}</td>
          <td colspan="4"><button type="submit"  class="btn btn-primary userlockBtn" (click)="sendForgotPassword(user.id)">{{'sendwelcome.sendwelcomeBtn'|translate}}</button></td>
        </tr>
        </tbody>
      </table>
      <pagination class="userLock" [directionLinks]="true" [boundaryLinks]="true" [totalItems]="totalItems" [(ngModel)]="currentPage" [maxSize]="5"
                  previousText="&#8592;" nextText="&#8594;" firstText="First" lastText="&#8677;"
                  [rotate]="false" (numPages)="numPages = $event"  (pageChanged)="pageChanged($event)"></pagination>

    </div>
  </div>
</div>
